<template>
  <div class="booster" :class="size">
    <img :src="src" :alt="alt" />
    <span v-if="complete" class="complete" aria-hidden="true">{{ complete }}</span>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    src: string
    alt: string
    size?: 'sm' | 'md' | 'lg'
    /** Completion label drawn on the booster, e.g. `47%`. */
    complete?: string
  }>(),
  { size: 'md' },
)
</script>

<style scoped>
.booster {
  position: relative;
  display: inline-block;
  filter: drop-shadow(0 12px 18px rgba(0, 0, 0, 0.55));
}

.booster.sm {
  width: 92px;
}

.booster.md {
  width: 132px;
}

.booster.lg {
  width: min(240px, 62vw);
}

.booster img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 3px;
}

.complete {
  position: absolute;
  left: 6px;
  right: 6px;
  bottom: 8px;
  z-index: 1;
  padding: 3px 4px;
  border-radius: 6px;
  background: color-mix(in srgb, var(--md-sys-color-surface) 88%, transparent);
  color: var(--md-sys-color-primary);
  font-family: Roboto, system-ui, sans-serif;
  font-size: 15px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
  line-height: 1.2;
  text-align: center;
  pointer-events: none;
  user-select: none;
  box-shadow: var(--md-elevation-1);
}

.booster.sm .complete {
  left: 4px;
  right: 4px;
  bottom: 5px;
  padding: 2px 3px;
  font-size: 11px;
  border-radius: 4px;
}

.booster.lg .complete {
  bottom: 12px;
  font-size: 22px;
}
</style>
